export default function CardGroup() {
  const cardImages = [
    '/images/card1.jpg',
    '/images/card2.jpg',
    '/images/card3.jpg',
    '/images/card4.jpg',
  ];

  const containerStyle = {
    background: 'linear-gradient(135deg, #24708b, #3e8eb0)',
    padding: '40px 20px',
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '24px',
    width: '100%',
    margin: '0 auto 60px auto', // bottom margin separates from DemoForm
    borderRadius: '12px',
    boxSizing: 'border-box',
    boxShadow: '0 8px 24px rgba(36, 112, 139, 0.25)',
  };

  const cardStyle = {
    width: '100%',
    aspectRatio: '4 / 3',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
  };

  const imageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  };

  return (
    <section style={containerStyle}>
      {cardImages.map((src, idx) => (
        <div key={idx} style={cardStyle}>
          <img src={src} alt={`card ${idx + 1}`} style={imageStyle} />
        </div>
      ))}
    </section>
  );
}
